import axios from "axios";

export default axios.create({
    baseURL: "https://api.weabonie.com"
    // baseURL: "http://localhost:8080"
})